import styled from 'styled-components';

import { GenericDiv } from '../../../../common/Styles';

export const DescWrapper = styled(GenericDiv)`
	text-align: center;
	padding: 90px 0;
	background-color: #eeeeee;
`;
